export interface DeprecationWarningOptions {
  deadlineVersion: string;
  property?: boolean;
  replaced: string;
  replacement?: string;
  scope: string;
  startingVersion: string;
}

export function deprecationWarning(options: DeprecationWarningOptions): void {
  const { property, deadlineVersion, replaced, replacement, scope, startingVersion } = options;

  if (property) {
    console.warn(
      '[%s]: The property %s is deprecated since version %s and will be removed in version %s.',
      scope,
      replaced,
      startingVersion,
      deadlineVersion,
    );

    return;
  }

  console.warn(
    `[%s]: The method %s is depreacated since version %s and will be removed in version %s. Please use '%s' instead.`,
    scope,
    replaced,
    startingVersion,
    deadlineVersion,
    replacement
  );
}

export default deprecationWarning;
